module.exports = __webpack_public_path__ + "img/certo.ae170e1b.jpg";